// extracted by mini-css-extract-plugin
export default {"inp_box":"MatrixGrid_inp_box__BpiXo","wrapper":"MatrixGrid_wrapper__Eeob2"};